<template>
    <div v-if="model">
        <rkm-form
            v-if="model"
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.unidade"
                        disabled
                        label="Unidade"
                        text-field="nomeFantasia"
                        v-model="model.unidadeId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.infraestrutura"
                        disabled
                        label="Local de atendimento"
                        text-field="nome"
                        v-model="model.infraestruturaId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.centrosCusto"
                        :validations="validations.centroCustoId"
                        @change="handleCentroCustoChange"
                        label="Setor"
                        show-default-option
                        text-field="setorNome"
                        v-model="model.centroCustoId"
                        value-field="centroCustoId"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.modulos"
                        :validations="validations.moduloId"
                        @change="handleModuloChange"
                        label="Módulo"
                        show-default-option
                        text-field="nome"
                        v-model="model.moduloId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input
                        :validations="validations.nome"
                        label="Nome"
                        v-model="model.nome"
                    >
                        <rkm-input-group-prepend slot="append">
                            <rkm-input-group-text>
                                <rkm-form-checkbox
                                    inline
                                    v-model="model.prioridadeObrigatoria"
                                >
                                    Prioridade obrigatória
                                </rkm-form-checkbox>
                            </rkm-input-group-text>
                        </rkm-input-group-prepend>
                    </rkm-form-input>
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input
                        :validations="validations.sigla"
                        label="Sigla"
                        v-model="model.sigla"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.faixasEtarias"
                        :validations="validations.faixaEtaria"
                        label="Perfil de atendimento"
                        show-default-option
                        text-field="nome"
                        v-model="model.faixaEtariaId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-area
            v-if="showBoxCentroCustoCompartilhado"
            no-margin-top
            title="Setor compartilhado"
        >
            <rkm-form ref="RkmFormCentroCustoCompartilhado">
                <rkm-row>
                    <rkm-col>
                        <rkm-form-select
                            :options="centrosCustoCompartilhado"
                            :validations="validations.centroCustoCompartilhado.centroCustoId"
                            label="Setor"
                            show-default-option
                            text-field="setorNome"
                            v-model="model.centroCustoCompartilhado.centroCustoId"
                            value-field="centroCustoId"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            @click="includeCentroCustoCompartilhado"
                            color="primary"
                        >
                            Incluir
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="resetFormCentroCustoCompartilhado"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>

            <rkm-row>
                <rkm-col colas="12">
                    <rkm-table
                        :fields="fields.centroCustoCompartilhado"
                        :items="model.centrosCustoCompartilhado"
                        hide-pagination
                    >
                        <template v-slot:cell(actions)="{index}">
                            <rkm-button
                                @click="destroyCentroCustoCompartilhado(index)"
                                color="danger"
                                small
                                title="Excluir"
                            >
                                <rkm-icon icon="trash" />
                            </rkm-button>
                        </template>
                    </rkm-table>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            v-if="showBoxOpcaoEntradaDestino"
            title="Opção de entrada de destino"
        >
            <rkm-form ref="RkmFormOpcaoEntradaDestino">
                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.opcaoEntradaDestino.modulos"
                            :validations="validations.opcaoEntradaDestino.moduloId"
                            @change="handleOpcaoEntradaDestinoModuloChange"
                            label="Módulo"
                            show-default-option
                            text-field="nome"
                            v-model="model.opcaoEntradaDestino.moduloId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.opcaoEntradaDestino.centrosCusto"
                            :validations="validations.opcaoEntradaDestino.centroCustoId"
                            @change="handleOpcaoEntradaDestinoCentroCustoChange"
                            label="Setor"
                            show-default-option
                            text-field="setorNome"
                            v-model="model.opcaoEntradaDestino.centroCustoId"
                            value-field="centroCustoId"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            :options="form.opcaoEntradaDestino.opcoesEntrada"
                            :validations="validations.opcaoEntradaDestino.opcaoEntradaId"
                            label="Opção de entrada"
                            show-default-option
                            text-field="nome"
                            v-model="model.opcaoEntradaDestino.opcaoEntradaId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            @click="includeOpcaoEntradaDestino"
                            color="primary"
                        >
                            Incluir
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="resetFormOpcaoEntradaDestino"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>

            <rkm-row>
                <rkm-col colas="12">
                    <rkm-table
                        :fields="fields.opcaoEntradaDestino"
                        :items="model.opcoesEntradaDestino"
                        hide-pagination
                    >
                        <template v-slot:cell(actions)="{index}">
                            <rkm-button
                                @click="destroyOpcaoEntradaDestino(index)"
                                color="danger"
                                small
                                title="Excluir"
                            >
                                <rkm-icon icon="trash" />
                            </rkm-button>
                        </template>
                    </rkm-table>
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </div>
</template>

<script>
// Enums.
import modulo from '@/enums/administracao/modulo'

// Mixins.
import { error, repository, stringCase } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({ lotacao: 'getLotacao' }),
        validations() {
            return {
                centroCustoId: { required: true },
                moduloId: { required: true },
                nome: {
                    required: true,
                    min:3,
                    max: 100,
                },
                sigla: {
                    required: true,
                    min: 2,
                    max: 2,
                },
                centroCustoCompartilhado: {
                    centroCustoId: { required: true },
                },
                opcaoEntradaDestino: {
                    centroCustoId: { required: true },
                    moduloId: { required: true },
                    opcaoEntradaId: { required: true },
                },
            }
        },
        showBoxCentroCustoCompartilhado() {
            const modulos = [this.enums.modulo.AMBULATORIO, this.enums.modulo.PRONTO_ATENDIMENTO]

            return !!this.form.modulos.find(modulo => modulo.id === this.model.moduloId && !modulos.includes(modulo.identificador))
        },
        showBoxOpcaoEntradaDestino() {
            const modulos = [
                this.enums.modulo.AMBULATORIO,
                this.enums.modulo.FARMACIA,
                this.enums.modulo.IMUNIZACAO,
                this.enums.modulo.PAINEL_SENHA,
            ]

            return !!this.form.modulos.find(modulo => modulo.id === this.model.moduloId && modulos.includes(modulo.identificador))
        },
        centrosCustoCompartilhado() {
            return this.form.centroCustoCompartilhado.centrosCusto.filter(centroCusto => centroCusto.centroCustoId !== this.model.centroCustoId)
        },
    },
    created() {
        this.repositories = {
            opcaoEntrada: this.getConectaSusRepository('painelSenha.opcaoEntrada')
        }
    },
    data: () => ({
        form: null,
        enums: {modulo},
        fields: {
            centroCustoCompartilhado: [
                {key: 'setorNome', label: 'Setor'},
                {class: 'col-min text-center', key: 'actions', label: 'Ações'},
            ],
            opcaoEntradaDestino: [
                {key: 'moduloNome', label: 'Módulo'},
                {key: 'setorNome', label: 'Setor'},
                {key: 'opcaoEntradaNome', label: 'Opção de entrada'},
                {class: 'col-min text-center', key: 'actions', label: 'Ações'},
            ],
        },
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            if (this.id) {
                this.repositories.opcaoEntrada.edit(this.id)
                    .then(response => {
                        this.form = Object.assign(
                            {
                                unidade: [{
                                    id: this.lotacao.infraestrutura.unidade.id,
                                    nomeFantasia: this.lotacao.infraestrutura.unidade.nomeFantasia,
                                }],
                                infraestrutura: [{
                                    id: this.lotacao.infraestrutura.id,
                                    nome: this.lotacao.infraestrutura.nome,
                                }],
                            },
                            response.data.form,
                        )

                        this.model = Object.assign(
                            {
                                unidadeId: this.lotacao.infraestrutura.unidade.id,
                                infraestruturaId: this.lotacao.infraestrutura.id,
                            },
                            response.data.model,
                        )
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            } else {
                this.repositories.opcaoEntrada.create()
                    .then(response => {
                        this.form = Object.assign(
                            {
                                unidade: [{
                                    id: this.lotacao.infraestrutura.unidade.id,
                                    nomeFantasia: this.lotacao.infraestrutura.unidade.nomeFantasia,
                                }],
                                infraestrutura: [{
                                    id: this.lotacao.infraestrutura.id,
                                    nome: this.lotacao.infraestrutura.nome,
                                }],
                            },
                            response.data.form,
                        )

                        this.model = Object.assign(
                            {
                                unidadeId: this.lotacao.infraestrutura.unidade.id,
                                infraestruturaId: this.lotacao.infraestrutura.id,
                            },
                            response.data.model,
                        )
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        handleCentroCustoChange() {
            this.model.centrosCustoCompartilhado = []
        },
        handleModuloChange() {
            this.model.centrosCustoCompartilhado = []
            this.model.opcoesEntradaDestino = []
        },
        handleOpcaoEntradaDestinoModuloChange(value) {
            this.form.opcaoEntradaDestino.centrosCusto = []
            this.form.opcaoEntradaDestino.opcoesEntrada = []
            this.model.opcaoEntradaDestino.centroCustoId = null
            this.model.opcaoEntradaDestino.opcaoEntradaId = null

            if (!value) return

            const request = {
                listar: 'centros-custo',
                moduloId: value,
                opcaoEntradaId: this.model.id ?? null,
            }

            this.setLoading()

            this.repositories.opcaoEntrada.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.form.opcaoEntradaDestino.centrosCusto = response.data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleOpcaoEntradaDestinoCentroCustoChange(value) {
            this.form.opcaoEntradaDestino.opcoesEntrada = []
            this.model.opcaoEntradaDestino.opcaoEntradaId = null

            if (!value) return

            const request = {
                listar: 'opcoes-entrada',
                moduloId: this.model.opcaoEntradaDestino.moduloId,
                centroCustoId: value,
                opcaoEntradaId: this.model.id ?? null,
            }

            this.setLoading()

            this.repositories.opcaoEntrada.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.form.opcaoEntradaDestino.opcoesEntrada = response.data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (!valid) return

                    this.setLoading()

                    if (this.model.id) {
                        this.repositories.opcaoEntrada
                            .update(this.model.id, this.camelObjectKeysToSnakeRecursive(this.model))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('save', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())

                    } else {
                        this.repositories.opcaoEntrada.store(this.camelObjectKeysToSnakeRecursive(this.model))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('save', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
        includeCentroCustoCompartilhado() {
            this.$refs.RkmFormCentroCustoCompartilhado.validate()
                .then(valid => {
                    if (!valid) return

                    if (this.model.centrosCustoCompartilhado.find(centroCustoCompartilhado => centroCustoCompartilhado.centroCustoId === this.model.centroCustoCompartilhado.centroCustoId)) {
                        this.showValidationNotification('O setor já foi incluído.')
                        return
                    }

                    const centroCustoCompartilhado = this.form.centroCustoCompartilhado.centrosCusto.find(centroCusto => centroCusto.centroCustoId === this.model.centroCustoCompartilhado.centroCustoId)

                    this.model.centrosCustoCompartilhado.push({
                        id: null,
                        centroCustoId: centroCustoCompartilhado.centroCustoId,
                        setorNome: centroCustoCompartilhado.setorNome,
                    })

                    this.resetFormCentroCustoCompartilhado()
                })
        },
        includeOpcaoEntradaDestino() {
            this.$refs.RkmFormOpcaoEntradaDestino.validate()
                .then(valid => {
                    if (!valid) return

                    if (this.model.opcoesEntradaDestino.find(opcaoEntradaDestino => opcaoEntradaDestino.opcaoEntradaId === this.model.opcaoEntradaDestino.opcaoEntradaId)) {
                        this.showValidationNotification('A opção de entrada já foi incluída.')
                        return
                    }

                    const modulo = this.form.opcaoEntradaDestino.modulos.find(modulo => modulo.id === this.model.opcaoEntradaDestino.moduloId)
                    const centroCusto = this.form.opcaoEntradaDestino.centrosCusto.find(centroCusto => centroCusto.centroCustoId === this.model.opcaoEntradaDestino.centroCustoId)
                    const opcaoEntrada = this.form.opcaoEntradaDestino.opcoesEntrada.find(opcaoEntrada => opcaoEntrada.id === this.model.opcaoEntradaDestino.opcaoEntradaId)

                    this.model.opcoesEntradaDestino.push({
                        id: null,
                        moduloId: modulo.id,
                        moduloNome: modulo.nome,
                        centroCustoId: centroCusto.centroCustoId,
                        setorNome: centroCusto.setorNome,
                        opcaoEntradaId: opcaoEntrada.id,
                        opcaoEntradaNome: opcaoEntrada.nome,
                    })

                    this.resetFormOpcaoEntradaDestino()
                })
        },
        destroyCentroCustoCompartilhado(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o setor de destino?', async () => {
                this.model.centrosCustoCompartilhado.splice(index, 1)
            })
        },
        destroyOpcaoEntradaDestino(index) {
            this.showDeleteConfirmation('Deseja realmente excluir a opção de entrada de destino?', async () => {
                this.model.opcoesEntradaDestino.splice(index, 1)
            })
        },
        resetFormCentroCustoCompartilhado() {
            this.model.centroCustoCompartilhado.centroCustoId = null
            this.$refs.RkmFormCentroCustoCompartilhado.resetValidator()
        },
        resetFormOpcaoEntradaDestino() {
            this.model.opcaoEntradaDestino = {
                moduloId: null,
                centroCustoId: null,
                opcaoEntradaId: null,
            }

            this.$refs.RkmFormOpcaoEntradaDestino.resetValidator()
        },
    },
    mixins: [ error, repository, stringCase ],
    mounted() {
        this.load()
    },
    props: {
        id: { type: [Number, String], default: null },
    },
}
</script>